import { Component, Input } from '@angular/core';
import module from "app/modules/annulus-pressure-record/annulus-pressure-record.module";

@Component({
  selector: 'apr-form',
  templateUrl: './apr-form.component.html',
  standalone: true,
  imports: module,
  styleUrls: ['./apr-form.component.scss']
})
export class AprFormComponent {
  @Input() form: any
}
